<dx-popup
    #attachmentSelectorPopup
    width="40%"
    height="50%"
    title="Email Attachment Selector"
    [showCloseButton]="true"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [(visible)]="visible"
    (onShown)="onShown()"
    (onHidden)="onHidden()"
>
    <div *dxTemplate="let item of 'content'">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <strong>Select Email Attachments(s) From The Grid Below To Include With WorkOrder.</strong>
                </div>
            </dxi-item>
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <dx-data-grid
                        #attachmentGrid
                        width="100%"
                        height="100%"
                        columnResizingMode="nextColumn"
                        noDataText="No data to display"
                        [dataSource]="attachments"
                        [showBorders]="true"
                        [showRowLines]="true"
                        [rowAlternationEnabled]="true"
                        [wordWrapEnabled]="true"
                        [hoverStateEnabled]="true"
                        [columnMinWidth]="30"
                        [columnAutoWidth]="true"
                        [allowColumnReordering]="true"
                        [allowColumnResizing]="true"
                        (onSelectionChanged)="onGridSelection()"
                    >
                        <dxo-selection showCheckBoxesMode="always" mode="multiple"></dxo-selection>
                        <dxi-column
                            dataField="fileName"
                            dataType="string"
                            caption="File Name"
                            cellTemplate="fileCellTemplate"
                        ></dxi-column>

                        <div *dxTemplate="let row of 'fileCellTemplate'">
                            <div *ngIf="!!row.data.fileName" class="attachment-container">
                                <i class="cc-1-5x" [ngClass]="getFileIcon(row.data.fileName)"></i>
                                &nbsp;
                                <app-hyperlink-creator
                                    mode="hyperlinkOnly"
                                    [displayText]="row.data.fileName"
                                    (onLinkClick)="onAttachmentDownload(d.data)"
                                ></app-hyperlink-creator>
                            </div>
                        </div>
                    </dx-data-grid>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate class="toolbar-container">
                    <dx-toolbar width="100%">
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Cancel"
                                    [icon]="iconCancel"
                                    (onClick)="onCancel()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button
                                    type="success"
                                    text="Attach"
                                    [disabled]="!isRowSelected"
                                    [icon]="iconAttachment"
                                    (onClick)="onSelect()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>
